(() => {
  const setup = () => {
    const grid = document.getElementById('zentron-howto-grid');
    const modal = document.getElementById('zentron-howto-modal');
    const player = document.getElementById('zentron-howto-modal-video');
    if (!grid || !modal || !player) return;
    let returnFocus = null;

    const clearYouTube = () => {
      modal.querySelector('[data-howto-youtube]')?.remove();
      modal.querySelector('[data-howto-external]')?.remove();
      modal.classList.remove('zentron-howto-modal--youtube');
      if (returnFocus) {
        returnFocus.focus();
        returnFocus = null;
      }
    };

    const openYouTube = opener => {
      const card = opener.closest('.zentron-howto-card');
      const shared = card?.querySelector('[data-share-url]');
      const url = shared?.dataset.shareUrl || '';
      const match = /^https:\/\/www\.youtube\.com\/watch\?v=([\w-]{11})$/.exec(url);
      if (!match) return false;
      const title = card.querySelector('.zentron-howto-card__title')?.textContent || 'Zentron tutorial';
      clearYouTube();
      player.pause();
      player.removeAttribute('src');
      player.load();
      returnFocus = opener;
      if (modal.parentElement !== document.body) document.body.appendChild(modal);
      const heading = document.getElementById('zentron-howto-modal-title');
      if (heading) heading.textContent = title;
      const share = document.getElementById('zentron-howto-modal-share');
      if (share) {
        share.dataset.shareTitle = title;
        share.dataset.shareUrl = url;
      }
      const iframe = document.createElement('iframe');
      iframe.dataset.howtoYoutube = '';
      iframe.src = `https://www.youtube-nocookie.com/embed/${match[1]}?autoplay=1&rel=0&playsinline=1`;
      iframe.title = title;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      modal.querySelector('.zentron-howto-modal__video-wrap')?.appendChild(iframe);
      const external = document.createElement('a');
      external.dataset.howtoExternal = '';
      external.className = 'zentron-howto-btn zentron-howto-btn--share';
      external.href = url;
      external.target = '_blank';
      external.rel = 'noopener noreferrer';
      external.textContent = 'Watch on YouTube';
      modal.querySelector('.zentron-howto-modal__controls')?.prepend(external);
      modal.classList.add('is-open', 'zentron-howto-modal--youtube');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('zentron-howto-modal-lock');
      document.getElementById('zentron-howto-modal-close')?.focus();
      return true;
    };

    document.addEventListener('click', event => {
      if (!(event.target instanceof Element)) return;
      const opener = event.target.closest('[data-video-index]');
      if (!event.target.closest('.zentron-howto-btn--share') && opener && grid.contains(opener) && openYouTube(opener)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      if (event.target.closest('#zentron-howto-modal-close') || event.target === modal) clearYouTube();
    }, true);

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') clearYouTube();
      const target = event.target;
      if ((event.key === 'Enter' || event.key === ' ') && target instanceof Element && target.matches('.zentron-howto-card__media[data-video-index]') && openYouTube(target)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
})();
